import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsEditComponent } from './reports-edit.component';
import { ReportsIssueCardModule } from './reports-issue-card/reports-issue-card.module';

@NgModule({
  imports: [
    CommonModule,
    ReportsIssueCardModule
  ],
  declarations: [ReportsEditComponent]
})
export class ReportsEditModule { }
